import { render } from "./prevBoardPopup.vue?vue&type=template&id=e25889e8&scoped=true"
import script from "./prevBoardPopup.vue?vue&type=script&lang=js"
export * from "./prevBoardPopup.vue?vue&type=script&lang=js"

import "./prevBoardPopup.vue?vue&type=style&index=0&id=e25889e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e25889e8"]])

export default __exports__